import { colors, styleConstants } from "../../../constants";
import { adjustHexColor } from "../../../util/general";

const {
  WHITE,
  TRANSPARENT,
  SAPPHIRE_BLUE,
  PEACOCK_BLUE,
  MANATEE_GREY,
  LUCKY_POINT,
  HINT_GREEN,
  SEA_GREEN,
  RASPBERRY,
  ERROR_COLOR,
  LUCKY_POINT_DARK,
  HAWKES_BLUE
} = colors;

const { LINK_TEXT_DECORATION } = styleConstants;

const disabledBorderColor = {
  primary: MANATEE_GREY,
  secondary: MANATEE_GREY,
  back: TRANSPARENT,
  smallPrimary: MANATEE_GREY,
  smallSecondary: MANATEE_GREY,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: MANATEE_GREY,
  dangerSecondary: MANATEE_GREY,
  whitePrimary: MANATEE_GREY,
  whiteSecondary: MANATEE_GREY,
  greenPrimary: SEA_GREEN,
  greenSecondary: SEA_GREEN
};

const disabledColor = {
  primary: WHITE,
  secondary: MANATEE_GREY,
  back: MANATEE_GREY,
  smallPrimary: WHITE,
  smallSecondary: MANATEE_GREY,
  smallGhost: MANATEE_GREY,
  ghost: MANATEE_GREY,
  tertiary: MANATEE_GREY,
  danger: WHITE,
  dangerSecondary: MANATEE_GREY,
  whitePrimary: MANATEE_GREY,
  whiteSecondary: MANATEE_GREY,
  greenPrimary: WHITE,
  greenSecondary: SEA_GREEN
};

const disabledBackgroundColor = {
  primary: MANATEE_GREY,
  secondary: TRANSPARENT,
  back: TRANSPARENT,
  smallPrimary: MANATEE_GREY,
  smallSecondary: TRANSPARENT,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: MANATEE_GREY,
  dangerSecondary: TRANSPARENT,
  whitePrimary: TRANSPARENT,
  whiteSecondary: TRANSPARENT,
  greenPrimary: SEA_GREEN,
  greenSecondary: TRANSPARENT
};

const padding = {
  primary: "0.75rem 1.5rem",
  secondary: "0.75rem 1.5rem",
  back: "0.75rem 1.5rem",
  smallPrimary: "0.75rem 1rem",
  smallSecondary: "0.75rem 1rem",
  smallGhost: "0",
  tertiary: "0.75rem 1.5rem",
  ghost: "0.65rem 0",
  danger: "0.75rem 1.5rem",
  dangerSecondary: "0.75rem 1.5rem",
  whitePrimary: "1.125rem 0.75rem",
  whiteSecondary: "0.75rem 2rem",
  greenPrimary: "0.75rem 1.5rem",
  greenSecondary: "0.75rem 1.5rem"
};

const color = {
  primary: WHITE,
  secondary: LUCKY_POINT,
  back: LUCKY_POINT,
  smallPrimary: WHITE,
  smallSecondary: LUCKY_POINT,
  smallGhost: LUCKY_POINT,
  ghost: LUCKY_POINT,
  tertiary: LUCKY_POINT,
  danger: WHITE,
  dangerSecondary: ERROR_COLOR,
  whitePrimary: WHITE,
  whiteSecondary: WHITE,
  greenPrimary: WHITE,
  greenSecondary: SEA_GREEN
};

const fontSizeVariant = {
  primary: "pS",
  secondary: "pS",
  back: "pS",
  smallPrimary: "pS",
  smallSecondary: "pS",
  smallGhost: "p",
  ghost: "pL",
  tertiary: "pS",
  danger: "pS",
  dangerSecondary: "pS",
  whiteSecondary: "pS",
  whitePrimary: "pS",
  greenPrimary: "pS",
  greenSecondary: "pS"
};

const fontWeight = {
  primary: "600",
  secondary: "600",
  back: "600",
  smallPrimary: "600",
  smallSecondary: "600",
  smallGhost: "400",
  ghost: "600",
  tertiary: "600",
  danger: "600",
  dangerSecondary: "600",
  whiteSecondary: "600",
  whitePrimary: "600",
  greenPrimary: "600",
  greenSecondary: "600"
};

const height = {
  primary: "3rem",
  secondary: "3rem",
  back: "3rem",
  smallPrimary: "2.5rem",
  smallSecondary: "2.5rem",
  smallGhost: "1.5rem",
  ghost: "3rem",
  tertiary: "3rem",
  danger: "3rem",
  dangerSecondary: "3rem",
  whitePrimary: "auto",
  whiteSecondary: "3rem",
  greenPrimary: "3rem",
  greenSecondary: "3rem"
};

const minWidth = {
  primary: "130px",
  secondary: "130px",
  back: "130px",
  smallPrimary: "100px",
  smallSecondary: "100px",
  smallGhost: "100px",
  ghost: "130px",
  tertiary: "130px",
  danger: "130px",
  dangerSecondary: "157px",
  whitePrimary: "130px",
  whiteSecondary: "160px",
  greenPrimary: "130px",
  greenSecondary: "130px"
};

const textDecoration = {
  primary: "none",
  secondary: "none",
  back: "none",
  smallPrimary: "none",
  smallSecondary: "none",
  smallGhost: LINK_TEXT_DECORATION,
  ghost: LINK_TEXT_DECORATION,
  tertiary: "none",
  danger: "none",
  dangerSecondary: "none",
  whitePrimary: "none",
  whiteSecondary: "none",
  greenPrimary: "none",
  greenSecondary: "none"
};

const backgroundColor = {
  primary: LUCKY_POINT,
  secondary: TRANSPARENT,
  back: TRANSPARENT,
  smallPrimary: LUCKY_POINT,
  smallSecondary: TRANSPARENT,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: RASPBERRY,
  dangerSecondary: TRANSPARENT,
  whitePrimary: TRANSPARENT,
  whiteSecondary: TRANSPARENT,
  greenPrimary: SEA_GREEN,
  greenSecondary: TRANSPARENT
};

const border = {
  primary: "2px solid " + LUCKY_POINT,
  secondary: "2px solid " + LUCKY_POINT,
  back: "2px solid " + LUCKY_POINT,
  smallPrimary: "2px solid " + LUCKY_POINT,
  smallSecondary: "2px solid " + LUCKY_POINT,
  smallGhost: "none",
  ghost: "none",
  tertiary: "none",
  danger: "2px solid " + RASPBERRY,
  dangerSecondary: "2px solid " + ERROR_COLOR,
  whitePrimary: "2px solid " + TRANSPARENT,
  whiteSecondary: "2px solid " + WHITE,
  greenPrimary: "2px solid " + SEA_GREEN,
  greenSecondary: "2px solid " + SEA_GREEN
};

const hoverBackgroundColor = {
  primary: LUCKY_POINT_DARK,
  secondary: HAWKES_BLUE,
  back: TRANSPARENT,
  smallPrimary: LUCKY_POINT_DARK,
  smallSecondary: HAWKES_BLUE,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: "#BA002C",
  dangerSecondary: "#FAE7EE",
  whitePrimary: TRANSPARENT,
  whiteSecondary: TRANSPARENT,
  greenPrimary: adjustHexColor(SEA_GREEN, 10, "darken"),
  greenSecondary: HINT_GREEN
};

const hoverBorderColor = {
  primary: LUCKY_POINT_DARK,
  secondary: LUCKY_POINT,
  back: "#DCEAF1",
  smallPrimary: LUCKY_POINT_DARK,
  smallSecondary: LUCKY_POINT,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: "#BA002C",
  dangerSecondary: "#B10541",
  whitePrimary: "2px solid " + TRANSPARENT,
  whiteSecondary: "2px solid " + TRANSPARENT,
  greenPrimary: SEA_GREEN,
  greenSecondary: SEA_GREEN
};

const hoverColor = {
  primary: WHITE,
  secondary: LUCKY_POINT,
  back: LUCKY_POINT,
  smallPrimary: WHITE,
  smallSecondary: LUCKY_POINT,
  smallGhost: LUCKY_POINT,
  ghost: LUCKY_POINT,
  tertiary: LUCKY_POINT,
  danger: WHITE,
  dangerSecondary: "#B10541",
  whitePrimary: WHITE,
  whiteSecondary: WHITE,
  greenPrimary: WHITE,
  greenSecondary: SEA_GREEN
};

const activeBackgroundColor = {
  primary: LUCKY_POINT_DARK,
  secondary: adjustHexColor(HAWKES_BLUE, 10, "darken"),
  back: TRANSPARENT,
  smallPrimary: LUCKY_POINT_DARK,
  smallSecondary: adjustHexColor(HAWKES_BLUE, 10, "darken"),
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: "#870000",
  dangerSecondary: "#FAE7EE",
  whitePrimary: TRANSPARENT,
  whiteSecondary: TRANSPARENT,
  greenPrimary: adjustHexColor(SEA_GREEN, 20, "darken"),
  greenSecondary: adjustHexColor(HINT_GREEN, 5, "darken")
};

const activeBorderColor = {
  primary: adjustHexColor(LUCKY_POINT_DARK, 10, "darken"),
  secondary: LUCKY_POINT,
  back: PEACOCK_BLUE,
  smallPrimary: adjustHexColor(LUCKY_POINT_DARK, 10, "darken"),
  smallSecondary: LUCKY_POINT,
  smallGhost: TRANSPARENT,
  ghost: TRANSPARENT,
  tertiary: TRANSPARENT,
  danger: "#870000",
  dangerSecondary: "#910029",
  whitePrimary: "2px solid " + TRANSPARENT,
  whiteSecondary: "2px solid " + TRANSPARENT,
  greenPrimary: SEA_GREEN,
  greenSecondary: SEA_GREEN
};

const activeColor = {
  primary: WHITE,
  secondary: LUCKY_POINT,
  back: PEACOCK_BLUE,
  smallPrimary: WHITE,
  smallSecondary: PEACOCK_BLUE,
  smallGhost: PEACOCK_BLUE,
  ghost: PEACOCK_BLUE,
  tertiary: PEACOCK_BLUE,
  danger: WHITE,
  dangerSecondary: "#910029",
  whitePrimary: WHITE,
  whiteSecondary: WHITE,
  greenPrimary: WHITE,
  greenSecondary: SEA_GREEN
};

export const fallbackValues = {
  padding,
  color,
  fontSizeVariant,
  fontWeight,
  height,
  minWidth,
  textDecoration,
  backgroundColor,
  border,
  hoverBackgroundColor,
  hoverBorderColor,
  hoverColor,
  activeBackgroundColor,
  activeBorderColor,
  activeColor,
  disabledColor,
  disabledBackgroundColor,
  disabledBorderColor
};
